const MemberTable = ({ members, onEdit, onDelete }) => {
  const isExpired = (date) => new Date(date) < new Date();

  return (
    <table className="w-full bg-white rounded-lg shadow overflow-hidden">
      <thead className="bg-gray-200">
        <tr>
          <th className="p-2 text-center">Name</th>
          <th className="p-2 text-center">Phone</th>
          <th className="p-2 text-center">Email</th>
          <th className="p-2 text-center">Category</th>
          <th className="p-2 text-center">Plan</th>
          <th className="p-2 text-center">Start</th>
          <th className="p-2 text-center">Expiry</th>
          <th className="p-2 text-center">Payment</th>
          <th className="p-2 text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        {members.map((m) => (
          <tr key={m.id}>
            <td className="p-2 text-center">{m.name}</td>
            <td className="p-2 text-center">{m.phone}</td>
            <td className="p-2 text-center">{m.email}</td>
            <td className="p-2 text-center">{m.category}</td>
            <td className="p-2 text-center">{m.plan}</td>
            <td className="p-2 text-center">
              {new Date(m.start_date).toLocaleDateString()}
            </td>
            <td
              className={`p-2 text-center ${
                isExpired(m.expiry_date) ? "text-red-500" : ""
              }`}
            >
              {new Date(m.expiry_date).toLocaleDateString()}
            </td>
            <td
              className={`p-2 text-center ${
                m.payment_status.startsWith("Pending")
                  ? "text-yellow-600"
                  : "text-green-600"
              }`}
            >
              {m.payment_status}
            </td>
            <td className="p-2 text-center">
              <button
                onClick={() => onEdit(m)}
                className="text-blue-500 mr-2"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(m.id)}
                className="text-red-500"
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MemberTable;